<div class="container">

  <div class="hero">
    <!-- <img class="hero-image" src="assets/how-to-watch/where_to_watch_header.png" /> -->
    <div class="hero-image"></div>
  </div>

  <div class="main">
    <table class="table" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <td>&nbsp;</td>
          <td class="center">Short Clips</td>
          <td class="center">Extended Clips</td>
          <td class="center">Full Episodes</td>
          <td class="center">Live Broadcasts</td>
          <td class="center">Podcasts</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of table">
          <td>
            <a target="_blank" [attr.href]="row[2] ? row[2] : null">
              <img class="platform-image" alt="{{ row[0] }}" src="{{ row[1] }}" />
            </a>
          </td>
          <td class="center">{{ row[3] }}</td>
          <td class="center">{{ row[4] }}</td>
          <td *ngIf="row[5] == 'Member'" class="center">
            <tyt-plus-locked></tyt-plus-locked> Exclusive
          </td>
          <td *ngIf="row[5] != 'Member'" class="center">{{ row[5] }}</td>
          <td *ngIf="row[6] == 'Member'" class="center">
            <tyt-plus-locked></tyt-plus-locked> Exclusive
          </td>
          <td *ngIf="row[6] != 'Member'" class="center">{{ row[6] }}</td>
          <td *ngIf="row[7] == 'Member'" class="center">
            <tyt-plus-locked></tyt-plus-locked> Exclusive
          </td>
          <td *ngIf="row[7] != 'Member'" class="center">{{ row[7] }}</td>
        </tr>
        <tr>
          <td colspan="6"><a href="{{joinUrl}}">
              <tyt-form-submit-button>Become a Member</tyt-form-submit-button>
            </a></td>
        </tr>
      </tbody>
    </table>
  </div>

</div>